import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import Logo from "../components/Logo";
import { api, formatApiError } from "../lib/api";
import { useLang } from "../i18n";

export default function AdminLogin() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/login", form);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const field = "w-full rounded-xl border border-ngo-deep/20 bg-white px-4 py-3.5 text-sm text-ngo-ink focus:outline-none focus:ring-2 focus:ring-ngo-leaf/50 focus:border-ngo-leaf transition-[box-shadow,border-color] duration-200";

  return (
    <main className="min-h-screen bg-ngo-forest flex items-center justify-center px-4">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-md bg-ngo-cream rounded-3xl p-9 shadow-2xl">
        <div className="flex flex-col items-center text-center mb-8">
          <Logo size={56} />
          <h1 data-testid="admin-login-heading" className="mt-4 font-heading font-bold text-2xl text-ngo-ink flex items-center gap-2">
            <Lock size={20} className="text-ngo-deep" />
            {t("admin.login")}
          </h1>
        </div>
        <label className="block text-sm font-semibold text-ngo-ink mb-2" htmlFor="a-email">{t("admin.email")}</label>
        <input id="a-email" data-testid="admin-email" type="email" required className={field} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <label className="block text-sm font-semibold text-ngo-ink mb-2 mt-5" htmlFor="a-pass">{t("admin.password")}</label>
        <input id="a-pass" data-testid="admin-password" type="password" required className={field} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={busy}
          className="mt-8 w-full py-4 rounded-full bg-ngo-deep text-white font-bold hover:bg-ngo-forest disabled:opacity-60 transition-colors duration-300"
        >
          {busy ? "..." : t("admin.loginBtn")}
        </button>
      </form>
    </main>
  );
}
